//NOTE autogenerated by export script
export {AllDevicesService as AllDevices} from './allDevices.service'
export {AnimalSpeciesCustomersService as AnimalSpeciesCustomers} from './animalSpeciesCustomers.service'
export {BootloaderVersionsService as BootloaderVersions} from './bootloaderVersions.service'
export {ConfigFilesService as ConfigFiles} from './configFiles.service'
export {DeviceClassesService as DeviceClasses} from './deviceClasses.service'
export {DeviceTypesCustomerService as DeviceTypesCustomer} from './deviceTypesCustomer.service'
export {FirmwareClassesService as FirmwareClasses} from './firmwareClasses.service'
export {FirmwareVersionsService as FirmwareVersions} from './firmwareVersions.service'
export {PCBTypesService as PCBTypes} from './pCBTypes.service'
export {ParameterListVersionService as ParameterListVersion} from './parameterListVersion.service'
export {ParametersCategoriesService as ParametersCategories} from './parametersCategories.service'
export {ParametersCustomerService as ParametersCustomer} from './parametersCustomer.service'
export {SchedulesService as Schedules} from './schedules.service'
export {SubsystemsService as Subsystems} from './subsystems.service'
export {BASE_PATH} from '../variables'
export {ApiModule} from '../api.module'
export {AllServices as All} from './allService'